import { SelectChangeEvent, ListItem, Select, MenuItem, ListItemText } from '@mui/material';
import { useMemo, useState } from 'react';
import {
  IComposableDashboardFiltersContext,
  ComposableDashboardFiltersEnum,
  IDependentFilters,
} from 'wisestep-api';

import { allSmartDateOptionsArrayForComposable } from '../../../../features/analytics/utils/smartDateSelectHelper';
import { useComposableDashboardsFiltersContext } from '../../hooks/useComposableDashboardsFiltersContext';

interface ISmartFilterDropdownOption {
  label: string;
  optionsUI?: JSX.Element[];
  options: string[];
}

type FiltersWithSmartOptions = ComposableDashboardFiltersEnum.DATE_RANGE;

const SmartFiltersOption = () => {
  const { filtersAdddedToDashboard, dependentFilters, setDependentFilters } =
    useComposableDashboardsFiltersContext() as Required<IComposableDashboardFiltersContext>;
  const [selectedFilters, addToSelectedFilters] = useState<IDependentFilters>(dependentFilters);
  const listOfFilters: FiltersWithSmartOptions[] = [];
  const { smartFilters: smartDateFilters } = selectedFilters;
  const dropDownOptions: Record<FiltersWithSmartOptions, ISmartFilterDropdownOption> = useMemo(
    () => ({
      [ComposableDashboardFiltersEnum.DATE_RANGE]: {
        label: 'Smart Date Filters',
        optionsUI: allSmartDateOptionsArrayForComposable.map((f) => (
          <MenuItem key={f} value={f} style={{ fontSize: '0.9rem' }}>
            {f}
          </MenuItem>
        )),
        options: smartDateFilters,
      },
    }),
    [smartDateFilters]
  );
  const handleChange = (
    event: SelectChangeEvent<string[]>,
    filterEnum: FiltersWithSmartOptions
  ) => {
    if (filterEnum === ComposableDashboardFiltersEnum.DATE_RANGE) {
      const {
        target: { value },
      } = event;
      const dateFilters = typeof value === 'string' ? value.split(',') : value;
      addToSelectedFilters((prev) => ({ ...prev, smartFilters: dateFilters }));
      setDependentFilters((p) => ({
        ...p,
        smartFilters: dateFilters,
      }));
    }
  };
  const getCountOfConditionalFilters = () => {
    if (filtersAdddedToDashboard?.indexOf(ComposableDashboardFiltersEnum.DATE_RANGE) > -1)
      listOfFilters.push(ComposableDashboardFiltersEnum.DATE_RANGE);
    return listOfFilters.length;
  };
  return getCountOfConditionalFilters() > 0 ? (
    <>
      {listOfFilters.map((filterEnum) => (
        <ListItem
          disableGutters
          sx={{ borderBottom: '1px solid black', marginTop: '2px' }}
          key={filterEnum}
          secondaryAction={
            <Select
              multiple
              value={dropDownOptions[filterEnum].options ?? []}
              onChange={(e) => handleChange(e, filterEnum)}
              style={{ height: '2rem', width: '16vw', overflow: 'clip' }}
              SelectDisplayProps={{
                style: { fontSize: '0.9rem' },
              }}
            >
              {dropDownOptions[filterEnum].optionsUI}
            </Select>
          }
        >
          <ListItemText primary={dropDownOptions[filterEnum].label} />
        </ListItem>
      ))}
    </>
  ) : (
    <></>
  );
};

export default SmartFiltersOption;
